/**
 * section-benefits.js
 * Scroll-triggered fade-up animations for Benefits Section.
 * Works with any Shopify theme — no custom element required.
 */

(function () {
  function initSection(section) {
    var elements = section.querySelectorAll('.afu');
    if (!elements.length) return;

    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    elements.forEach(function (el) { observer.observe(el); });
  }

  // Init all instances on page load
  document.querySelectorAll('.benefits-section').forEach(initSection);

  // Re-init when Shopify Theme Editor reloads a section
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.benefits-section');
    if (section) initSection(section);
  });
})();
